import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

type Props = {
  visible: boolean
  onHide: () => void
  onConfirm: () => void
}

const UnsavedChangesWarningDialog = (props: Props) => {
  const footer = (
    <div className="text-center">
      <Button label="CANCEL" className="default-cancel-button" onClick={props.onHide} />
      <Button label="YES" className="default-save-button" onClick={props.onConfirm} />
    </div>
  )

  return (
    <Dialog
      header={<div className="mr-4">Unsaved Changes Confirmation</div>}
      footer={footer}
      visible={props.visible}
      onHide={props.onHide}
      className="default max-w-[95dvw]"
    >
      <p className="m-0">Are you sure you want to close the email editor?</p>
      <p className="m-0">Any unsaved changes will be lost.</p>
    </Dialog>
  )
}

export default UnsavedChangesWarningDialog
